import { render, staticRenderFns } from "./Inject.vue?vue&type=template&id=990cc164&scoped=true&"
import script from "./Inject.vue?vue&type=script&lang=js&"
export * from "./Inject.vue?vue&type=script&lang=js&"
import style0 from "./Inject.vue?vue&type=style&index=0&id=990cc164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990cc164",
  null
  
)

export default component.exports